export default __webpack_public_path__ + "static/media/bg-video-cyan.9c5cea1c.mp4";